/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* -------------------------- Design imports start -------------------------- */
/* --------------------------- Design imports end --------------------------- */
/* ------------------------ Functional imports start ------------------------ */
import Cookies from 'js-cookie'
import { Redirect, Route } from 'react-router-dom'

import { isPrivileged } from '../../utils/functions'
/* ------------------------- Functional imports end ------------------------- */
interface Props {
  component?: any
  layout: any
  title?: string
  showBack?: boolean
  onBackClick?: () => void
  [x: string]: any
}

interface AuthProps extends Props {
  showSettings?: boolean
  user: any
  componentStaffView?: any
  guestUserRedirect?: string
  notStaffUserRedirect?: string
}

export const PublicRoute = ({
  component: Component,
  layout: Layout,
  title,
  showBack,
  onBackClick,
  ...rest
}: Props) => (
  <Route
    {...rest}
    render={(props: { [x: string]: any }) => (
      <Layout title={title} showBack={showBack} onBackClick={onBackClick}>
        <Component {...props} />
      </Layout>
    )}
  />
)

export const AuthenticatedRoute = (props: AuthProps) => {
  const {
    user,
    layout: Layout,
    showSettings,
    showBack,
    onBackClick,
    title,
    component: Component,
    staffViewComponent: StaffViewComponent,
    guestUserRedirect, // specify a page that guest users should be redirected to, because they are not permitted to view the contents of the rout
    notStaffUserRedirect, // specify a page that non STAFF users should be redirected to, because they are not permitted to view the contents of the rout
    ...rest
  } = props
  return (
    <Route
      {...rest}
      render={props => {
        if (guestUserRedirect && user && user.isGuestUser) {
          return <Redirect to={{ pathname: guestUserRedirect, state: { from: props.location } }} />
        }
        if (notStaffUserRedirect && user && !isPrivileged(user, 'STAFF')) {
          return (
            <Redirect to={{ pathname: notStaffUserRedirect, state: { from: props.location } }} />
          )
        }
        if (user || Cookies.get('refresh')) {
          return (
            <Layout
              title={title}
              showBack={showBack}
              showSettings={showSettings}
              onBackClick={onBackClick}
            >
              {user && user.isStaff && StaffViewComponent ? (
                <StaffViewComponent {...props} />
              ) : (
                <Component {...props} />
              )}
            </Layout>
          )
        }
        return <Redirect to={{ pathname: '/signIn', state: { from: props.location } }} />
      }}
    />
  )
}
